export const hasStringLengthEqual = (value: string, length: number): boolean => {
    return value?.length === length;
};

export const startsWith = (value: string, firstCharacter: string): boolean => {
    return value[0] === firstCharacter;
};

export const startsWithZero = (value: string): boolean => startsWith(value, '0');
